import { useTranslation } from 'react-i18next';

import cs from 'classnames';

import HTMLText from 'components/HTMLText/HTMLText';

import { ApplicationWithOfferLetter } from 'types/applications';

import { ApplicationTags } from 'constants/enums';

import styles from './OfferLetterDetails.module.scss';

interface OfferLetterDetailsProps {
  applicationWithOfferLetter: ApplicationWithOfferLetter | null;
  applicationTags?: string[] | null;
}

const OfferLetterDetails = ({
  applicationWithOfferLetter,
  applicationTags
}: OfferLetterDetailsProps) => {
  const { t } = useTranslation();

  if (!applicationWithOfferLetter) {
    return null;
  }

  const { application, variables } = applicationWithOfferLetter;

  const JobDetails = [
    {
      label: t('sidebar.application.offerLetter.jobTitle'),
      value: application.jobName
    },
    {
      label: t('sidebar.application.offerLetter.location'),
      value: variables.company_location
    },
    {
      label: t('sidebar.application.offerLetter.compensation'),
      value: `${variables.salary} ${variables.frequency}`
    },
    {
      label: t('sidebar.application.offerLetter.workSchedule'),
      value: variables.work_schedule
    },
    {
      label: t('sidebar.application.offerLetter.startDate'),
      value: t('sidebar.application.offerLetter.dateToBeConfirmed')
    },
    {
      label: t('sidebar.application.offerLetter.pointOfContract'),
      value: variables.poc_name
    }
  ];

  return (
    <div
      className={cs(styles.bodyWrapper, {
        [styles.disabled]: applicationTags?.includes(
          ApplicationTags.DeclinedApplicationStageWithdrawn
        )
      })}
    >
      <div className={styles.blockWrapper}>
        <span className={styles.textEmphasized}>{variables.company_name}</span>
        <span> {variables.company_address}</span>
        <span className={styles.textSecondary}>{variables.today}</span>
      </div>

      <span>
        <HTMLText
          text={t('sidebar.application.offerLetter.dearName', {
            name: variables.jobseeker_name
          })}
        />
      </span>

      <span>
        <HTMLText
          text={t('sidebar.application.offerLetter.weArePleased', {
            title: variables.job_title,
            company: variables.company_name,
            location: variables.company_location
          })}
        />
      </span>

      <div className={styles.blockWrapper}>
        <span>{t('sidebar.application.offerLetter.theDetails')}</span>
        <ul>
          {JobDetails.map((detail) => (
            <li key={detail.label}>
              {`${detail.label} `}
              <strong>{`${detail.value} `}</strong>
            </li>
          ))}
        </ul>
      </div>

      <div className={styles.blockWrapper}>
        <span>{t('sidebar.application.offerLetter.lookForward')}</span>
        <span>
          <HTMLText
            text={t('sidebar.application.offerLetter.shouldYouHave', {
              name: variables.poc_name
            })}
          />
        </span>
      </div>

      <div className={styles.blockWrapper}>
        <span>{t('sidebar.application.offerLetter.sincerely')}</span>
        <span>
          <strong>{variables.poc_name}</strong>
        </span>
        {variables.poc_position && (
          <span>
            <strong>{variables.poc_position}</strong>
          </span>
        )}
        <span>
          <strong>{variables.company_name}</strong>
        </span>
      </div>

      <div className={styles.divider} />

      <div className={styles.blockWrapper}>
        <span className={styles.textSecondaryGray}>
          {t('sidebar.application.offerLetter.confidentiality')}
        </span>
        <span className={styles.textSecondaryGray}>
          {t('sidebar.application.offerLetter.decline')}
        </span>
      </div>
    </div>
  );
};

export default OfferLetterDetails;
